<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { getSmsClient } from '@/services/sms'
import Multiselect from 'vue-multiselect'
import { workOrderTypesOdoo } from '../lib/workOrderTypesOdoo'
import { workOrderStatesOdoo } from '../lib/workOrderStatesOdoo'

const vsmsSmsAxios = getSmsClient()

export default {
  page: {
    title: 'Validation',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  props: {
    status: String,
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
  },

  mixins: [Helper],

  data() {
    return {
      workOrders: [],
      workOrdersSms: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: ['text'],
      isSort: false,
      isEdit: false,
      filteredItems: [],
      newDataId: 1,
      loading: false,
      realData: 0,
      filterValidation: {
        all: true,
        requestToValidate: false,
        requestToVerify: false,
        requestToComplete: false,
      },
      woTypes: [],
    }
  },

  watch: {
    '$route.query.wo': {
      immediate: true,
      handler(wo) {
        if (!wo) return
        this.loadData(wo)
      }
    }
  },

  created() {
    if (!this.$route.query.wo) {
      this.loadData()
    }
  },

  computed: {
    totalRows() {
      return this.filteredWorkOrders.length
    },

    title() {
      return this.$t('workOrder.column.validation')
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return this.workOrder.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.workOrder
      }
    },

    workOrder() {
      const stateMapping = workOrderStatesOdoo()
      const typeMapping = workOrderTypesOdoo()
      return [
        {
          key: 'wo_number',
          label: this.$t('workOrder.table.woNumber'),
          sortable: true,
        },
        {
          key: 'customer',
          label: this.$t('workOrder.table.customer'),
          sortable: true,
        },
        {
          key: 'teknisi',
          label: this.$t('workOrder.table.technician'),
          sortable: true,
        },
        {
          key: 'plan_date',
          label: this.$t('workOrder.table.processingDate'),
          sortable: true,
        },
        {
          key: 'actual_installation',
          label: this.$t('workOrder.table.actualInstall'),
          sortable: true,
        },
        {
          key: 'type_wo',
          label: this.$t('workOrder.table.woType'),
          formatter: (value) => {
            // Mencari mapping yang sesuai
            const mapping = typeMapping.find((map) => map.code === value)
            return mapping ? mapping.name : value
          },
          sortable: true,
        },
        {
          key: 'state',
          label: this.$t('workOrder.table.woStatusErp'),
          formatter: (value) => {
            const mapping = stateMapping.find((map) => map.code === value)
            return mapping ? mapping.name : value
          },
          sortable: true,
        },
        {
          key: 'wo_status',
          label: this.$t('workOrder.table.woStatus'),
          formatter: (value) => {
            switch (value) {
              case 'C':
                return 'Cancel'
              case 'I':
                return 'In Progress'
              case 'D':
                return 'Done'
              default:
                break
            }
          },
          sortable: true,
        },
        {
          key: 'version',
          label: this.$t('workOrder.table.version'),
          sortable: true,
        },
      ]
    },

    woTypeOptions() {
      return workOrderTypesOdoo()
    },

    filteredWorkOrders() {
      let filtered = this.workOrders

      // Apply work order type filter
      if (this.woTypes.length > 0) {
        filtered = filtered.filter((workOrder) =>
          this.woTypes.some((type) => type.code === workOrder.type_wo)
        )
      }

      // Apply search filter if exists
      if (this.filter) {
        const searchTerm = this.filter.toLowerCase()
        filtered = filtered.filter((item) => {
          return this.visibleFields.some((field) => {
            const value = item[field.key]
            return value && String(value).toLowerCase().includes(searchTerm)
          })
        })
      }

      return filtered
    },
  },

  methods: {
    loadData(wo) {
      this.filter = wo // otomatis isi filter search

      this.filterByValidation()
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 400) {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              this.$toast.error(
                `${error.response.data.error} : ${element.field} ${element.message}`
              )
            })
          }
        } else if (error.response.status === 401) {
          this.$toast.error(error.response.data.error)
        } else if (error.response.status === 403) {
          this.$toast.error(error.response.data.error)
        } else {
          this.$toast.error(error.response.data.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    async getTotalActualInstall(woId) {
      let actualInstall = 0
      const tasks = await vsmsSmsAxios.get('/tasks/' + woId).catch((error) => {
        this.handleError(error)
      })

      if (!tasks?.data) {
        return actualInstall
      }

      actualInstall = tasks.data.length
      return actualInstall
    },

    updateFilterValidation(param) {
      this.filterValidation[param] = !this.filterValidation[param]
      Object.keys(this.filterValidation).forEach((key) => {
        if (key !== param) {
          this.filterValidation[key] = false
        }
      })
      this.filterByValidation()
    },

    async filterByValidation() {
      let filters = ''
      if (this.filterValidation.requestToValidate) {
        filters = encodeURIComponent('tasks.tasksStatus:in:R|NC;workOrderStatus:eq:I')
      } else if (this.filterValidation.requestToVerify) {
        filters = encodeURIComponent('tasks.tasksStatus:all:V;verifyDate:is:NULL')
      } else if (this.filterValidation.requestToComplete) {
        filters = encodeURIComponent('endDate:isnot:NULL;workOrderStatus:eq:I')
      }
      this.loading = true
      const workOrder = await vsmsSmsAxios.get(`/work-order?filters=${filters}`).catch((error) => {
        this.handleError(error)
      })
      if (!workOrder) {
        this.loading = false
        return
      }
      this.workOrders = workOrder.data.data
      this.loading = false
    },

    onFiltered() {
      this.currentPage = 1
    },

    generateLink(item) {
      return `/work-order/validation/form/${item.wo_number}`
    },

    validateForm() {
      this.$v.$touch()
      return this.$v.$error
    },

    resetForm() {
      return this.$v.$reset()
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('workOrder.column.validation') }}</span>
            </template>

            <template>
              <div>
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="clearfix">
                          <!-- Search -->
                          <div class="float-start">
                            <multiselect v-model="woTypes" :options="woTypeOptions" :multiple="true"
                              :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                              :hide-selected="true" :allow-empty="true" placeholder="Select work order types"
                              label="name" track-by="code" class="mb-2" style="min-width: 202px" />
                          </div>
                          <div class="float-end">
                            <label class="d-inline-flex align-items-center mc-table-view__search">
                              <i class="mc-fa fas fa-search"></i>
                              <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                                class="ms-2" />
                            </label>
                          </div>
                          <!-- End search -->
                        </div>

                        <!-- Filter By Request Validate -->
                        <b-button :variant="filterValidation.all ? 'secondary' : 'light'" size="sm" class="me-3"
                          :class="filterValidation.all ? 'request-validate-tab' : ''"
                          @click="updateFilterValidation('all')">
                          {{ $t('workOrder.filterValidation.all') }}
                        </b-button>
                        <b-button :variant="filterValidation.requestToValidate ? 'secondary' : 'light'" size="sm"
                          class="me-3" :class="filterValidation.requestToValidate ? 'request-validate-tab' : ''"
                          @click="updateFilterValidation('requestToValidate')">
                          {{ $t('workOrder.filterValidation.waitingForValidation') }}
                        </b-button>
                        <b-button :variant="filterValidation.requestToVerify ? 'secondary' : 'light'" size="sm"
                          class="me-3" :class="filterValidation.requestToVerify ? 'request-validate-tab' : ''"
                          @click="updateFilterValidation('requestToVerify')">
                          {{ $t('workOrder.filterValidation.waitingForVerification') }}
                        </b-button>
                        <b-button :variant="filterValidation.requestToComplete ? 'secondary' : 'light'" size="sm"
                          class="me-3" :class="filterValidation.requestToComplete ? 'request-validate-tab' : ''"
                          @click="updateFilterValidation('requestToComplete')">
                          {{ $t('workOrder.filterValidation.watingToComplete') }}
                        </b-button>
                        <!-- End Filter By Request Validate -->

                        <!-- Table Tracking -->
                        <div class="table-responsive my-2 border border-1">
                          <b-table class="datatables" :items="filteredWorkOrders" :fields="visibleFields"
                            responsive="sm" show-empty :empty-text="$t('global.emptyTable')"
                            :empty-filtered-text="$t('global.emptyFilteredTable')" :busy="loading" small empty-table
                            :no-local-sorting="isSort" :per-page="perPage" :current-page="currentPage" :filter="filter"
                            @filtered="onFiltered">
                            <template #cell(wo_number)="data">
                              <strong>
                                <a :href="generateLink(data.item)" class="text-primary">
                                  {{ data.item.wo_number ? data.value : '-' }}
                                </a>
                              </strong>
                            </template>
                            <template #cell(wo_status)="data">
                              {{ data.item.wo_status ? data.value : '-' }}
                            </template>
                            <template #cell(customer)="data">
                              {{ data.item.customer ? data.value : '-' }}
                            </template>
                            <template #cell(plan_date)="data">
                              {{
                                data.item.plan_date
                                  ? data.item.version
                                    ? momentDMHms(data.value)
                                    : momentDMHmsUtc(data.value)
                                  : '-'
                              }}
                            </template>
                            <template #cell(actual_installation)="data">
                              {{ data.item.actual_installation ? data.value : '0' }}
                            </template>
                            <template #cell(type_wo)="data">
                              {{ data.item.type_wo ? data.value : '-' }}
                            </template>
                            <template #cell(state)="data">
                              {{ data.item.state ? data.value : '-' }}
                            </template>
                            <template #cell(version)="data">
                              {{ data.item.version ? data.value : '-' }}
                            </template>
                            <template #table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                              </div>
                            </template>
                          </b-table>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_length" class="dataTables_length" v-if="!loading">
                              <label class="d-inline-flex align-items-center">
                                <span>Menampilkan</span>
                                <span>
                                  <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                                    :options="pageOptions" />
                                </span>
                                <span>entri.&nbsp;&nbsp;</span>
                                <span>Menampilkan&nbsp;
                                  <strong>
                                    {{
                                      filteredWorkOrders.length > 0
                                        ? (currentPage - 1) * perPage + 1
                                        : 0
                                    }}
                                  </strong>
                                  &nbsp;sampai&nbsp;
                                  <strong>
                                    {{ Math.min(totalRows, currentPage * perPage) }}
                                  </strong>
                                  &nbsp;dari&nbsp;
                                  <strong>{{ totalRows }}</strong>
                                  &nbsp;entri.
                                </span>
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination v-if="!loading" v-model="currentPage" :total-rows="totalRows"
                                  :per-page="perPage" />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
